export class AmmsCategoryMap {
    public id: number;
    public locationId:number;
    public systemId:number;
    public categoryId:number;
    public ammsServiceCodeId:number;
    public ammsUnitCodeId:number;
    public ammsResourceId:number;
    public ammsLocationId:number;
}